import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const notices = [{
  name: 'Natalia T.',
  city: 'Mendoza',
  product: 'MegaPack Completo'
}, {
  name: 'Gustavo A.',
  city: 'Salta',
  product: 'MegaPack Completo'
}, {
  name: 'Verónica D.',
  city: 'Mar del Plata',
  product: 'MegaPack Completo'
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % notices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = notices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-203" data-mp="1z3re05147bos">
      <AnimatePresence data-id="element-204" data-mp="237z3w5jb6xol">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} aria-live="polite" className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-2xl bg-white p-4 shadow-lift ring-1 ring-blue-100" data-id="element-205" data-mp="286isyet78pl6">
            <div className="min-w-0 flex-1" data-id="element-206" data-mp="1p8pmx3na3zjk">
              <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em] text-mint-600" data-id="element-207" data-mp="rsaj9ktj2aqy">
                <span className="h-2 w-2 rounded-full bg-mint-500" aria-hidden="true" data-id="element-208" data-mp="wq2989am3msi" />
                Compra verificada
              </p>
              <p className="mt-2 text-sm font-bold text-ink" data-id="element-209" data-mp="1zzwstyba3i7a">
                {notice.name} de {notice.city}
              </p>
              <p className="truncate text-sm text-blue-900/70" data-id="element-210" data-mp="28u34kzlkszrv">
                Compró <span className="font-semibold text-blue-700" data-id="element-211" data-mp="28wfo3h6zfi71">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-blue-900/45" data-id="element-212" data-mp="24v3rgrpoxwpc">hace 2 minutos</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="rounded-md p-1 text-blue-900/40 transition-colors duration-150 ease-calm hover:bg-blue-50 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-213" data-mp="1h59iil8hssad">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-214" data-mp="31hp8k8ypu6f9" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}